import React from "react"

const toneClassMap = {
    neutral: "border-borderColor bg-white text-tColor hover:border-accent hover:bg-accent/10 hover:text-accent",
    success: "border-green-200 bg-green-50 text-green-700 hover:bg-green-100",
    danger: "border-red-200 bg-red-50 text-red-700 hover:bg-red-100",
    primary: "border-primeColor/20 bg-primeSoft text-primeColor hover:border-primeColor hover:bg-primeColor hover:text-white",
}

const TableActionButton = ({ title, tone = "neutral", onClick, children }) => {
    return (
        <button
            type="button"
            title={title}
            aria-label={title}
            className={`inline-flex h-9 w-9 items-center justify-center rounded-xl border text-base shadow-sm transition ${toneClassMap[tone] || toneClassMap.neutral}`}
            onClick={onClick}
        >
            {children}
        </button>
    )
}

export default TableActionButton
